export const env =
  window?.location?.origin === 'https://admin.eyes-aid.com'
    ? 'https://api.eyes-aid.com/'
    : 'https://api.staging.eyes-aid.com/';
